import { Container } from "components/layout/Container";
import { Heading } from "components/layout/Heading";
import styles from "./SectionSEO.module.scss";
import { EditorContent } from "../../pages/article/EditorContent";
import { EditorContentData } from "@/components/pages/article/EditorContent/types";
import cn from "classnames";
import { RichText } from "@/components/shared/content_ai/Richtext";
import st from "@/styles/modules/common.module.scss";

type SectionSeoProps = {
  heading: string;
  subheading?: string;
  content: string;
  headingCircles?: boolean;
  plainHTML?: boolean;
};

export const SectionSEO = ({ heading, subheading, content, headingCircles, plainHTML }: SectionSeoProps) => {
  let parsedContent: EditorContentData | undefined;
  try {
    parsedContent = JSON.parse(content);
  } catch (err) {}

  return (
    <section
      className={cn(styles.section, {
        [styles.withHeadingCircles]: headingCircles,
      })}
    >
      <Container className={styles.container}>
        <Heading title={heading} subheading={subheading} className={styles.heading} subheadingSize="small" />
        {plainHTML ? (
          <RichText className={cn(st.articleContent, styles.content)} content={content} />
        ) : (
          <EditorContent data={parsedContent} className={styles.content} />
        )}
      </Container>
    </section>
  );
};

export default SectionSEO;
